module.exports = __webpack_public_path__ + "static/media/NEWS-vertical.6162404b.png";